
export const UICExportHelper = {
    drawingsLayerCSS: [
        'div.leaflet-tooltip-pane',
        'div.leaflet-marker-pane',
        'div.leaflet-popup-pane',
        'div.leaflet-overlay-pane'
    ],
    baseLayerCSS: [ 'div.baseTileLayer' ],            // base tile layers
    areaLayerCSS: [ 'div.areaTileLayer' ],            // area tile layers

    _createLayersFilterFromCheckboxes: function (elementFetcher) {
        // parses options and tunes pdf module
        let css = []
        let el = elementFetcher('drawing')
        // exclude drawings (geometries) from export
        if (el && !el.checked) {
            css = css.concat(this.drawingsLayerCSS)
        }

        el = elementFetcher('raster')
        if (el && !el.checked) {
            css = css.concat(this.areaLayerCSS)
        }

        el = elementFetcher('base-map')
        if (el && !el.checked) {
            css = css.concat(this.baseLayerCSS)
        }
        return css
    },

    /**
     * adds array to array, return new array
     * @param target
     * @param arrToAdd
     * @returns {*}
     * @private
     */
    _addToTargetArray: function (target, arrToAdd) {
        return this._arrayUnique(target.concat(arrToAdd))
    },

    /**
     * removes arrToRemove array elements from target array, do work in place modifying the target array
     * @param target
     * @param arrToRemove
     * @private
     */
    _removeFromTargetArray: function (target, arrToRemove) {
        let i = 0;
        while (i < target.length) {
            let done = false
            for (let j = 0; j < arrToRemove.length; j++) {
                if (target[i] === arrToRemove[j]) {
                    target.splice(i, 1);
                    done = true
                }
            }
            if (!done) {
                i++
            }
        }
        return target
    },

    /**
     * deduplicates array
     * @param array
     * @returns {*}
     * @private
     */
    _arrayUnique: function (array) {
        let a = array.concat();
        for(let i=0; i<a.length; ++i) {
            for(let j=i+1; j<a.length; ++j) {
                if(a[i] === a[j])
                    a.splice(j--, 1);
            }
        }

        return a;
    }
}
